import { Component } from "@angular/core";

@Component({
	selector: "sdp-spinner-overlay",
	template: "<mat-spinner></mat-spinner>"
})
export class SpinnerOverlayComponent {
}
